import { PoleClassification } from '../../../../../../api/theHive/redeProto/types';
import { CLASSIFICATION_LABEL } from '../../../../../../constants/redeProto';
import { classificationColorOf, neutralColor } from '../../theme/tokens';
import { EMPTY_VALUE } from '../../utils/format';
import { Pill } from './styles';

interface StatusPillProps {
  classification: PoleClassification | null;
}

export function StatusPill({ classification }: StatusPillProps): JSX.Element {
  return (
    <Pill
      color={
        classification ? classificationColorOf(classification) : neutralColor
      }
    >
      {classification ? CLASSIFICATION_LABEL[classification] : EMPTY_VALUE}
    </Pill>
  );
}
